// JsFromRoutes CacheKey 48a69c5163e945acd3d3197927b78a52
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const contactInfo = {
  edit: definePathHelper("get", "/contact_info/:id/edit"),
  update: definePathHelper("patch", "/contact_info/:id"),
};
